/**
 * Live feedback, computed from the numbers and the marks alone (CLAUDE.md §10): the answer key
 * never reaches this code. Only what can no longer be right is flagged.
 */
import type { Feedback } from "../types";
import { resizeRows } from "./progress";
import { contradictions } from "./rules";
import { cellId, type NurikabeDefinition, type NurikabeProgress } from "./types";

export function localFeedback(
  definition: NurikabeDefinition,
  progress: NurikabeProgress,
): Feedback[] {
  const marks = resizeRows(progress.rows, definition.rows, definition.cols);
  const found = contradictions(definition.clues, marks);
  const feedback: Feedback[] = found.pools.map(([r, c]) => ({
    type: "pool",
    code: "shaded_pool",
    cells: [cellId(r, c), cellId(r, c + 1), cellId(r + 1, c), cellId(r + 1, c + 1)],
  }));
  if (found.islands.length > 0)
    feedback.push({
      type: "island",
      code: "island_contradiction",
      cells: found.islands.map(([r, c]) => cellId(r, c)),
    });
  if (found.walls.length > 0)
    feedback.push({
      type: "wall",
      code: "wall_cut_off",
      cells: found.walls.map(([r, c]) => cellId(r, c)),
    });
  return feedback;
}
